// extracted by mini-css-extract-plugin
export default {"relaxed-default":"styles__relaxed-default--D4x7Q"};